<template>
  <div>
    <div class="text-primary" v-if="object.blocked == 0">Активен</div>
    <div class="text-secondary" v-if="object.blocked == 1">Заблокирован</div>
    <div class="text-danger" v-if="object.blocked == 2 || object.deleted_at">Удален</div>
  </div>
</template>

<script>
export default {
  name: "SuperAdminDatatableTDUserBlocked",
  props: {
    object: {
      type: Object
    }
  },
}
</script>

<style scoped>

</style>
